import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteIcon from "@material-ui/icons/Delete";

import PerfectScrollbar from "react-perfect-scrollbar";
import {
  aboutUsFormDataSelecter,
  aboutUsAddedSelector,
  loadAboutUs,
  addAboutUs,
  deleteAboutUs,
} from "../store/aboutUs";

import { getBrokerageInformation, getDetails } from "../store/brokerage";
import Select from "react-dropdown-select";
import FormEditor from "../../src/brokeragesuperadmin/FormEditor";
import translations from "../utils/translations";
import { getBrokerInformation } from "../store/broker";

const BrokerageAdminAboutUs = (props) => {
  const dispatch = useDispatch();
  const information = useSelector(getBrokerageInformation);

  const [selectedBrokerageCode, setSelectedBrokerageCode] = useState(null);
  useEffect(() => {
    dispatch(getDetails());
  }, []);
  useEffect(() => {
    if (information?.code !== undefined) {
      dispatch(loadAboutUs(information?.code));
    }
  }, [information?.code]);

  return <AboutUsWrapper brokerageCode={information?.code}></AboutUsWrapper>;
};

export const AboutUsWrapper = (props) => {
  const dispatch = useDispatch();
  let allAbout = useSelector(aboutUsFormDataSelecter);
  const [toggleUpdateUserModel, setToggleUpdateUserModel] = useState(false);
  const [toggleCancelUserModel, setToggleCancelUserModel] = useState(false);
  const [toggleNewUserModel, settoggleNewUserModel] = useState(false);
  const [aboutUsIndex, setAboutUsIndex] = useState(0);
  const information = useSelector(getBrokerageInformation);
  let justAdded = useSelector(aboutUsAddedSelector);
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;
  const onNewUserModelChangeHandle = (value) => {
    settoggleNewUserModel(value);
  };
  const onUpdateUserModelChangeHandle = (value, index) => {
    setAboutUsIndex(index);
    setToggleUpdateUserModel(value);
  };
  const onCancelUserModelChangeHandle = (value, index) => {
    setAboutUsIndex(index);
    setToggleCancelUserModel(value);
  };
  useEffect(() => {
    if (justAdded) dispatch(loadAboutUs(props.brokerageCode));
  }, [justAdded]);
  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-4"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            {translationsBrokerAdmin.aboutUsHeader}
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
            }}
          >
            <table className="table  table-sm">
              <thead>
                <tr>
                  <th scope="col">
                    {" "}
                    {translationsBrokerAdmin.aboutUsTitleName}
                  </th>
                  <th scope="col"> {translationsBrokerAdmin.body}</th>
                  <th scope="col" className="text-center">
                    {translationsBrokerAdmin.action}
                  </th>
                </tr>
              </thead>
              <tbody>
                {allAbout.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item?.title}</td>
                      <td>{item?.body[0]?.data?.text}</td>
                      <td className="text-center">
                        <Button
                          style={{
                            color: "white",
                            height: "3.5vh",
                            fontFamily: "GibsonSemiBd",
                            fontSize: 12,
                            backgroundColor: theme.COLORS.secondary_skyblue,
                            border: 0,
                            width: "5vw",
                          }}
                          onClick={() =>
                            onUpdateUserModelChangeHandle(true, index)
                          }
                        >
                          {translationsBrokerAdmin.update}
                        </Button>
                        <DeleteIcon
                          color="error"
                          style={{
                            height: "3.5vh",
                            fontFamily: "GibsonSemiBd",
                            fontSize: 12,
                            border: 0,
                            width: "3vw",
                            margin: "0 .5rem",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            // dispatch(
                            //   deleteAboutUs({
                            //     code: props.brokerageCode,
                            //     id: item?._id,
                            //   })
                            // );

                            onCancelUserModelChangeHandle(true, index);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div>
            <Button
              style={{
                color: "white",
                height: "4vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                border: 0,
                width: "10vw",
              }}
              onClick={() => {
                onNewUserModelChangeHandle(true);
              }}
            >
              {translationsBrokerAdmin.aboutUsAddButton}
            </Button>
          </div>
        </div>
      </div>
      <AddUserModal
        brokerageCode={props.brokerageCode}
        settoggleNewUserModel={settoggleNewUserModel}
        toggleNewUserModel={toggleNewUserModel}
        aboutUsIndex={aboutUsIndex}
        aboutUsList={allAbout}
      ></AddUserModal>
      <UpdateUserModal
        brokerageCode={props.brokerageCode}
        setToggleUpdateUserModel={setToggleUpdateUserModel}
        toggleUpdateUserModel={toggleUpdateUserModel}
        aboutUsList={allAbout}
        aboutUsIndex={aboutUsIndex}
      ></UpdateUserModal>
      <ConfirmDeleteModal
        brokerageCode={props.brokerageCode}
        setToggleCancelUserModel={setToggleCancelUserModel}
        toggleCancelUserModel={toggleCancelUserModel}
        aboutUsList={allAbout}
        aboutUsIndex={aboutUsIndex}
      ></ConfirmDeleteModal>
    </div>
  );
};

const AddUserModal = (props) => {
  return (
    <Modal
      size="md"
      isOpen={props.toggleNewUserModel}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "65vh",
          width: "40vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <NewUser
        brokerageCode={props.brokerageCode}
        settoggleNewUserModel={props.settoggleNewUserModel}
        toggleNewUserModel={props.toggleNewUserModel}
        setAboutUsList={props.setAboutUsList}
        aboutUsList={props.aboutUsList}
        aboutUsIndex={props.aboutUsIndex}
      ></NewUser>
    </Modal>
  );
};

const NewUser = (props) => {
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              Add a new About Us
            </span>
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => {
                props.settoggleNewUserModel(false);
              }}
            ></CancelIcon>
          </div>
        </div>
        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-10">
            <FormEditor
              buttonText="Add about us"
              aboutUsList={props.aboutUsList}
              setAboutUsList={props.setAboutUsList}
              aboutUsIndex={props.aboutUsIndex}
              brokerageCode={props.brokerageCode}
              settoggleNewUserModel={props.settoggleNewUserModel}
            />
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};
const UpdateUserModal = (props) => {
  return (
    <Modal
      size="md"
      isOpen={props.toggleUpdateUserModel}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "70vh",
          width: "50vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "auto",
        },
      }}
    >
      <UpdateUser
        brokerageCode={props.brokerageCode}
        setToggleUpdateUserModel={props.setToggleUpdateUserModel}
        toggleUpdateUserModel={props.toggleUpdateUserModel}
        aboutUsList={props.aboutUsList}
        setAboutUsList={props.setAboutUsList}
        aboutUsIndex={props.aboutUsIndex}
      ></UpdateUser>
    </Modal>
  );
};

const ConfirmDeleteModal = (props) => {
  return (
    <Modal
      size="md"
      isOpen={props.toggleCancelUserModel}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "18vh",
          width: "30vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "auto",
        },
      }}
    >
      <CancelUser
        brokerageCode={props.brokerageCode}
        setToggleCancelUserModel={props.setToggleCancelUserModel}
        toggleUpdateUserModel={props.toggleUpdateUserModel}
        aboutUsList={props.aboutUsList}
        setAboutUsList={props.setAboutUsList}
        aboutUsIndex={props.aboutUsIndex}
      ></CancelUser>
    </Modal>
  );
};

const UpdateUser = (props) => {
  return (
    <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
      <div className="row ml-1 p-3">
        <div>
          <span
            className="text-center"
            style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
          >
            Update About Us
          </span>
        </div>

        <div
          className="ml-auto"
          style={{ marginTop: "-15px", marginRight: "-10px" }}
        >
          <CancelIcon
            fontSize="small"
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.setToggleUpdateUserModel(false);
            }}
          ></CancelIcon>
        </div>
      </div>

      <div
        className="row pt-3  justify-content-center"
        style={{
          fontFamily: "GibsonRegular",
        }}
      >
        <div className="col-8">
          <FormEditor
            buttonText="Update"
            aboutUsList={props.aboutUsList}
            setAboutUsList={props.setAboutUsList}
            brokerageCode={props.brokerageCode}
            aboutUsIndex={props.aboutUsIndex}
            setToggleUpdateUserModel={props.setToggleUpdateUserModel}
          />
        </div>
      </div>
    </div>
  );
};

const CancelUser = (props) => {
  const dispatch = useDispatch();
  return (
    <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
      <div className="row ml-1 p-3">
        <div>
          <span
            className="text-center"
            style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
          >
            Are you sure you want to delete?
          </span>
        </div>

        <div
          className="ml-auto"
          style={{ marginTop: "-15px", marginRight: "-10px" }}
        >
          <CancelIcon
            fontSize="small"
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.setToggleCancelUserModel(false);
            }}
          ></CancelIcon>
        </div>
      </div>

      <div
        className="row pt-3  justify-content-center"
        style={{
          fontFamily: "GibsonRegular",
        }}
      >
        <div
          className="col-8"
          style={{ display: "flex", justifyContent: "space-evenly" }}
        >
          <Button
            style={{
              color: "white",
              height: "3.5vh",
              fontFamily: "GibsonSemiBd",
              fontSize: 12,
              backgroundColor: theme.COLORS.red_star,
              border: 0,
              width: "5vw",
            }}
            onClick={() => {
              dispatch(
                deleteAboutUs({
                  code: props.brokerageCode,
                  id: props.aboutUsList[props.aboutUsIndex]?._id,
                })
              );
              setTimeout(() => {
                props.setToggleCancelUserModel(false);
              }, 400);
            }}
          >
            Yes
          </Button>

          <Button
            style={{
              color: "white",
              height: "3.5vh",
              fontFamily: "GibsonSemiBd",
              fontSize: 12,
              backgroundColor: theme.COLORS.secondary_skyblue,
              border: 0,
              width: "5vw",
            }}
            onClick={() => props.setToggleCancelUserModel(false)}
          >
            No
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BrokerageAdminAboutUs;
